import Container from "react-bootstrap/Container";
import Header from "./components/Header";
import Posts from "./components/Posts";
import React from "react";
import Footer from "./components/Footer";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
import Sitemap from "./components/Sitemap";
import SinglePage from "./components/SinglePage";

const App = () => {
  return (
    <Router>
      <Header>
        <ul className="hList headerTitles">
          <label>KAPOFF!</label>
          <li>Sound</li>
          <li>Music</li>
          <li>Film</li>
          <li className="divider"> - </li>
          <li>Jerker Osatie</li>
          <li>
            <a href="mailto:jerker@kapoff.se">jerker@kapoff.se</a>
          </li>
          <li>+46 70 236 25 41</li>
        </ul>
      </Header>
      <Container>
        <main>
          <Switch>
            <Route exact path="/" component={Posts} />

            <Route path="/sitemap" component={Sitemap} />

            <Route path="/page/:id" component={SinglePage} />
          </Switch>
        </main>
      </Container>

      <Footer>
        <ul className="hList text-center">
          <li>Copyright 2020 Kapoff Produktion</li>
          <li className="divider">-</li>
          <li>
            <Link to="/sitemap">Sitemap</Link>
          </li>
        </ul>
      </Footer>
    </Router>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js